import { TabStyles, Tooltip } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

export function BridgeMultiPoolTableHeaders() {
  return <>
    <tbody>
      <tr>
        <th className={`${poolTableHeadersLine} ${poolTableHeadersSmallWidth}`} data-tb-test-id={'pool-expand-icon-column-header'}/>
        <th className={poolTableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-name-column-header'}>
            {Messages.bridgeSiteSettingsPoolColumnName()}
          </span>
        </th>
        <th className={poolTableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-all-clients-column-header'}>
            {Messages.bridgeSiteSettingsPoolAllClientsColumnName()}
          </span>
        </th>
        <th className={poolTableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-active-clients-column-header'}>
            {Messages.bridgeSiteSettingsPoolActiveClientsColumnName()}
          </span>
        </th>
        <th className={poolTableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-status-column-header'}>
            {Messages.bridgeSiteSettingsPoolStatusColumnName()}
            {getPoolStatusTooltip()}
          </span>
        </th>
        <th className={poolTableHeadersLine} data-tb-test-id={'pool-actions-column-header'}/>
      </tr>
    </tbody>
  </>;
}

function getPoolStatusTooltip() {
  return (
    <Tooltip testId={'pool-status-tooltip'} getContent={() => { return <span>{Messages.bridgeSiteSettingsPoolTooltip()}</span>; }}>
      <img className={bridgeTooltipClass} src={imgPath('info_normal.svg')} alt={''} />
    </Tooltip>
  );
}

export const bridgeTooltipClass = style({
  height: CommonStyles.Sizes.ExtraSmallIconSize,
  marginLeft: TabStyles.Spacing.SmallSpace,
  verticalAlign: 'text-top',
  outlineStyle: 'none'
});

export const poolTableHeadersLine = style({
  height: CommonStyles.Sizes.DataGridHeaderHeight,
  borderBottomWidth: CommonStyles.Sizes.LineWidth,
  borderBottomColor: CommonStyles.Colors.DividerLineColor,
  borderBottomStyle: 'solid',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  backgroundColor: CommonStyles.Colors.White,
  borderSpacing: 0
});

export const poolTableHeadersSmallWidth = style({
  width: '35px'
});
